// extracted by mini-css-extract-plugin
export var buttons = "_4d-0";
export var buttonsActive = "_4d-h";
export var cancelConfirm = "_4d-1";
export var closeButton = "_4d-2";
export var column = "_4d-3";
export var container = "_4d-4";
export var detailHeader = "_4d-6";
export var detailTitle = "_4d-7";
export var detailsContent = "_4d-5";
export var header = "_4d-8";
export var headerWithClose = "_4d-9";
export var icon = "_4d-a";
export var infoIcon = "_4d-c";
export var informationContainer = "_4d-b";
export var sideDrawer = "_4d-d";
export var sideDrawerOpen = "_4d-e";
export var stickyFooter = "_4d-f";
export var typeOption = "_4d-g";